import React from 'react';

const Header: React.FC = () => (
  <div
    className="header"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '32px 48px 0 48px'
    }}
  >
    <div
      className="logo"
      style={{
        display: 'flex',
        alignItems: 'center',
        fontSize: '2rem',
        fontWeight: 'bold',
        letterSpacing: 2,
        minWidth: 180,
        minHeight: 56
      }}
    >
      <img
        src="/images/logo/logo.png"
        alt="Velours logo"
        className="logo-img"
        style={{ height: 48, width: 'auto', display: 'block' }}
      />
    </div>
    <div
      className="topbar"
      style={{
        color: '#fff',
        fontSize: '1rem',
        opacity: 0.8,
        marginRight: 32
      }}
    >
      The contents of this page are fake and have been created by Velours for a simulation exercise
      <a
        href="https://www.groupevelours.com/pt-br/"
        target="_blank"
        rel="noopener"
        style={{
          color: '#fff',
          textDecoration: 'underline',
          marginLeft: 24,
          fontWeight: 500,
          fontSize: '1rem',
          transition: 'color 0.2s'
        }}
        onMouseOver={e => (e.currentTarget.style.color = '#00e0ff')}
        onMouseOut={e => (e.currentTarget.style.color = '#fff')}
      >
        Visit Velours' site &rarr;
      </a>
    </div>
  </div>
);

export default Header;